module.exports = __webpack_public_path__ + "img/Norte.d6c560b2.png";